import { base_colorContentBorderSecondary } from 'ext-ui/style/colors'
import {
  flyout_headerVSpacing,
  flyout_innerBlockVSpacing,
} from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${flyout_headerVSpacing};

  .managerReviewSection-content {
    display: flex;
    flex-direction: column;
    gap: ${flyout_innerBlockVSpacing};

    .managerReviewSection-content-list {
      & > *:not(:last-child) {
        ::after {
          content: '';
          margin: ${flyout_innerBlockVSpacing} 0;
          left: 0;
          right: 0;
          height: 1px;
          background: ${base_colorContentBorderSecondary};
        }
      }
    }
  }
`
